import { render } from "./Nav.vue?vue&type=template&id=7051896d&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=7051896d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oscar\\Documents\\GitHub\\ReSeT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7051896d"]])

export default __exports__